import { render, staticRenderFns } from "./pull_quote.vue?vue&type=template&id=605ada40&lang=pug"
import script from "./pull_quote.vue?vue&type=script&lang=js"
export * from "./pull_quote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports